import React from "react";
import { FormattedMessage } from "react-intl";
import { OrgButton } from "../OrgButton";

export function WorkspaceScheduledArchiveButton(props: {
  date: React.JSX.Element;
  disabled: boolean;
  onPress?: () => void;
}) {
  const title = (
    <FormattedMessage
      defaultMessage="Archive scheduled at {date}"
      description="WorkspaceScheduledArchiveButton title"
      values={{
        date: props.date,
      }}
    />
  );
  return (
    <OrgButton
      backgroundColor={
        props.disabled ? "transparent" : "surface-backgroundControl"
      }
      icon="archive"
      tintColor="text-secondary"
      onPress={props.onPress}
      disabled={props.disabled}
      title={title}
    />
  );
}
